var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 15.45,
    viewBox: "0 0 24 15.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21411",
    "data-name": "Group 21411",
    transform: "translate(-22932.189 -3586)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55679",
    "data-name": "Path 55679",
    d: "M286.72,219.384h1.572a1.1,1.1,0,0,1,1.092-1.092V216.72A2.672,2.672,0,0,0,286.72,219.384Z",
    transform: "translate(22654.459 3373.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55680",
    "data-name": "Path 55680",
    d: "M109.72,117.6c-5.754,0-10.415,5.3-11.72,6.926a1.281,1.281,0,0,0,0,1.6c1.305,1.625,5.967,6.926,11.72,6.926s10.415-5.3,11.72-6.926a1.281,1.281,0,0,0,0-1.6C120.135,122.9,115.474,117.6,109.72,117.6Zm0,12.466a4.741,4.741,0,1,1,4.741-4.741A4.752,4.752,0,0,1,109.72,130.066Z",
    transform: "translate(22834.469 3468.4)",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeBlack);
export default __webpack_public_path__ + "static/media/eye-black.20e303c855e66efc01da3f894483f16e.svg";
export { ForwardRef as ReactComponent };